import axiosInstance from './axios';
import { POST_CONTACTFORM } from './types';
import { reportResponse } from './helpers';

// POST CONTACT FORM
export const postContactForm = (formValues) => async dispatch => {
    const res = await axiosInstance.post('/contact/', { ...formValues });
    return reportResponse(res, POST_CONTACTFORM, 'Contact formulier', dispatch);
};